import { getSimpleDataSelector } from '@cp-shared-19/frontend-integration';
import { RootState } from '../../../../store/rootReducer';

export const StateContentSelector = getSimpleDataSelector((state: RootState) => state.content.stateCatalog);
